import {Directive, ElementRef} from "@angular/core";
import {OnlySymbolsDirective} from "./onlySymbols.directive";

/**
 * Allow enter only digits
 */
@Directive({
  selector: "[onlyDigits]"
})
export class OnlyDigitsDirective extends OnlySymbolsDirective {

  constructor(el: ElementRef) {
    super(el);
    this.mask = "[^0-9]";
    this.inputMode = "numeric";
  }

}
